module.exports = __webpack_public_path__ + "img/logo-blackInk.34d753d1.png";